<template lang="pug">
  .wrap
    page-title Edit Panel
    panel-form(v-if='panel' :panel='panel' @submit='onSave')

</template>

<script>
import { mapActions } from "vuex";
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import PanelForm from "../PanelForm";

export default {
  mixins: [CrudMixin],
  components: { PageTitle, PanelForm },
  data() {
    return {
      panel: null
    };
  },
  computed: {
    panelId() {
      return this.$route.params.panelId;
    }
  },
  methods: {
    ...mapActions("panels", ["fetchPanel", "updatePanel"]),
    loadData() {
      this.wrapLoadAction(this.fetchPanel)({ id: this.panelId }).then(data => {
        this.panel = data;
      });
    },
    onSave() {
      this.wrapApiAction(this.updatePanel)({ data: this.panel }).then(() => {
        this.$router.push({ name: "spage:panelList" });
      });
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped lang="scss"></style>
